import React from 'react'
import './Loader.scss'

const Loader = () => {
    return (
        <div className="loading-spinner">
        </div>
      );
}

export default Loader
